import React, { Component } from 'react'
import { connect } from 'react-redux'
import { totalPriceCal } from '../../JS/totalPriceCal'
import { setTotalOrderPrice, setHCommerceSavedOrders, changePage } from '../../../action/hcommerce'
import { CMSPath } from '../../../config/constant'
import PlaceOrder from './placeOrder'
import { getGuestInRoom } from '../../../action/action'
import { hCommColor } from '../../JS/colorConfig'
import { setShowPlaceOrder } from '../../action/hCommerce2';
import $ from 'jquery';
import { formatPriceForDisplay, getQuantityCountToBeDisplayed, removeItemHandler } from './itemActions';
import { contScrollToBottom, contScrollToTop, hideScrolltoTopHandler, hideScrolltoBottomHandler } from '../../JS/scroll';
import {withTranslation} from "react-i18next";
import { getDefaultAnalyticsLabel } from '../../JS/utility'
import { sendAnalytics } from '../../../action/homeAction'

class MyOrder extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showDetails: false,
            showCheckOut: false,
            savedOrders: [],
            showScrollToTop:false,
            hideBottomArrow: false,
            quantityCountToBeDisplayed:0
        }
        this.myOrderCont = document.getElementById("my-order")
    }

    componentWillMount() {
        let savedOrders = localStorage.getItem("savedOrders");
        if (savedOrders && savedOrders !== "null") {
            savedOrders = JSON.parse(savedOrders);
        } else {
            savedOrders = []
        }
        let totalPrice = totalPriceCal();
        this.props.setTotalOrderPrice(totalPrice);
        this.setState({ savedOrders: savedOrders, quantityCountToBeDisplayed : getQuantityCountToBeDisplayed(savedOrders) });
        // this.props.getGuestInRoom(this.props.guestDetail);
    }

    componentDidUpdate(preProp,prevState) {
        if (preProp.hCommerceSavedOrders !== this.props.hCommerceSavedOrders) {
            let savedOrders = localStorage.getItem("savedOrders");
            if (savedOrders && savedOrders !== "null") {
                savedOrders = JSON.parse(savedOrders);
            } else {
                savedOrders = []
            }
            this.setState({ savedOrders: savedOrders });
        }

        if(prevState.quantityCountToBeDisplayed != this.state.quantityCountToBeDisplayed){
            $('#my-orders').addClass("shake")
            setTimeout(() => {
                $('#my-orders').removeClass("shake")
            }, 500);
        }

        if(prevState.showDetails !== this.state.showDetails){
            if(this.state.showDetails){
                $("body").addClass("overlay-cast");
            }else{
                $("body").removeClass("overlay-cast");
            }
        }

        if(prevState.savedOrders!=this.state.savedOrders){
            this.setState({quantityCountToBeDisplayed : getQuantityCountToBeDisplayed(this.state.savedOrders)})
        }

        hCommColor(this.props.menuColor);
    }

    setShowDetails = () => {
        this.setState({ showDetails: !this.state.showDetails, showCheckOut: false })

        let cartEventSent = localStorage.getItem("cartEventSent") == "true"
        if(!this.state.showDetails && !cartEventSent){
            let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
        
            this.props.sendAnalytics(
                this.props.guestDetail, 
                this.props.currentWidgets.widgetType, 
                "CART", 
                {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "widgetSessionId": localStorage.getItem("hcommerceSessionToken"), storeName: this.props.storeInfo.storeName, pageName: "CART"},
                0, 
                this.props.guestIsLoggedIn,
                () => localStorage.setItem("cartEventSent", true)
            );
        }

    }

    showCheckoutPage = () => {
         

        this.props.setShowPlaceOrder(true)
    }

    increaseQuantity = (item) => {
        let totalPrice
        let copyOrder = [...this.state.savedOrders]
        copyOrder.map((iterator, index) => {
            if (iterator.id === item.id) {
                iterator.quantity = iterator.quantity + 1
                iterator.totalPrice = iterator.totalPrice + item.item.itemPrice
                totalPrice = this.props.totalPrice + item.item.itemPrice
            }
        })
        this.setState({ savedOrders: copyOrder });
        this.props.setHCommerceSavedOrders(copyOrder);
        this.props.setTotalOrderPrice(totalPrice);
        copyOrder = JSON.stringify(copyOrder);
        localStorage.setItem("savedOrders", copyOrder);
    }

    decreaseQuantity = (item) => {
        let totalPrice
        let copyOrder = [...this.state.savedOrders]
        copyOrder.map((iterator, index) => {
            if (iterator.id === item.id) {
                if (iterator.quantity === 1) {
                    copyOrder.splice(index, 1);
                    totalPrice = this.props.totalPrice - iterator.totalPrice
                } else {
                iterator.quantity = iterator.quantity - 1
                iterator.totalPrice = iterator.totalPrice - item.item.itemPrice
                totalPrice = this.props.totalPrice - item.item.itemPrice
                }
            }
        })
        this.setState({ savedOrders: copyOrder });
        this.props.setHCommerceSavedOrders(copyOrder);
        this.props.setTotalOrderPrice(totalPrice);
        copyOrder = JSON.stringify(copyOrder);
        localStorage.setItem("savedOrders", copyOrder);
    }

    checkOut = () => {
        this.setState({ showDetails: !this.state.showDetails, showCheckOut: true });
        this.props.setShowPlaceOrder(true)
    }

    setNextPage = () => {
        this.props.openAdditionalDetail()
    }

    afterSubmit = (event) => {
        console.log("called On submit")
        event.preventDefault();
    }

    removeItemHandlerCallback = (savedOrders) => {
        this.setState({ savedOrders: savedOrders });
    }

    showAddonsHandler = (addons) => {

        if(!addons || addons.length === 0){
            return
        }

        const addOnNames = [];

        addons.map((obj) => {
            if(obj.quantity > 0){
                addOnNames.push(obj.name);
            }
        })

        return addOnNames.toString();
        
    }


    handleScroll = () => {
        hideScrolltoBottomHandler('my-order', (bool) => this.setState({ hideBottomArrow: bool }))
        hideScrolltoTopHandler("my-order",(bool) => this.setState({showScrollToTop:bool}))
    }


    componentDidMount(){
        if(this.props.mapOpened){
            this.setState({ showDetails: false, showCheckOut: true });
        }
        hCommColor(this.props.menuColor);
    }

    componentWillUnmount() {
        $("body").removeClass("overlay-cast");
    }

    render() {
        const { t } = this.props
        let imagePath = null;
        return (
            <section id='my-orders' onClick={this.showCheckoutPage} class={`my-orders orders-fb ${this.state.showDetails ? "overlay" : ""}`}>
                <div class="orders-container">
                         <div class="amt" style={{ display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                            <span class="total">Total</span>
                             <span class="order-total-amt">{this.props.currencyCode} {formatPriceForDisplay(this.props.totalPrice, this.props.precisionLength )}</span>
                        </div>
                    <div class="orders-heading">
                        <h5>{t('hcommerce.checkout.my_orders')} <span class="cart-item" >{this.state.quantityCountToBeDisplayed}</span></h5>
                        <a onClick={this.setShowDetails} class="order-toggle">
                            <i className={
                                this.state.showDetails ? "fas fa-lg fa-chevron-down" : "fas fa-lg fa-chevron-up"
                            }
                            ></i>
                        </a>
                    </div>
                    {/* <form onSubmit={this.afterSubmit}>
                        <div class="orders-body-container"
                            style={!this.state.showDetails ? { display: "none" } : {}}>
                            <div class="orders-body-scroller" style={this.state.savedOrders.length > 4 ? {} : { display: "none" }}>
                                {this.state.showScrollToTop && <div onClick = {() => contScrollToTop("my-order")} class="orders-scroll scroll-up"><i class="fa fas fa-chevron-up"></i></div>}
                                { !this.state.hideBottomArrow && <div onClick = {() => contScrollToBottom("my-order")} class="orders-scroll scroll-down"><i class="fa fas fa-chevron-down"></i></div>}
                            </div>
                            <div id="my-order" onScroll={this.handleScroll} class="orders-body" style={{padding:"1rem"}}>
                                {
                                    this.state.savedOrders.map((iterator) => {
                                        imagePath=null;
                                        if (iterator.item.storeItemImages.length === 1) {
                                            imagePath = `${CMSPath}${iterator.item.storeItemImages[0].imagePath}`
                                        } else {
                                            iterator.item.storeItemImages.map((images) => {
                                                if (images.imageType === "LARGE") {
                                                    imagePath = encodeURI(`${CMSPath}${images.imagePath}`)
                                                }
                                            })
                                        }
                                        return (
                                            <div class="row order-row">
                                                <div class="close" style = {{
                                                    backgroundColor: this.props.menuColor.assetBackgroundSelectorColor
                                                }}
                                                onClick={() => removeItemHandler(iterator,this.props,this.removeItemHandlerCallback)}>
                                                    <i class="fa fa-times"></i>
                                                </div>
                                                <div class="col col-4 order-preview" style={{background: `url('${imagePath}') center center no-repeat`, height: "100%", width: "30%",backgroundSize: "cover"}}></div>
                                                <div class="col order-details">
                                                    <div class="order-name">
                                                        <p class="item-name" dangerouslySetInnerHTML={{__html: `${iterator.item.itemName}`}}></p>
                                                        <p class="qty align-center">{iterator.quantity}</p>
                                                    </div>
                                                    <div class="order-qty">
                                                        {(iterator.addOns && iterator.addOns.length > 0)? <p class="item-addons">{this.showAddonsHandler(iterator.addOns)}</p>: <p class="item-addons"></p>}
                                    
                                                        <p class="item-amt" dangerouslySetInnerHTML={{__html: `${this.props.currencyCode} ${iterator.totalPrice}`}}></p>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div class="controls">
                                <input type="submit" name="Next" value="Next" className="inputSubmit"
                                    onClick={this.setNextPage}/>
                            </div>
                        </div>
                    </form> */}
                </div>
            </section>
        )
    }
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        // currentPage: state.store.Hcommerce.currentPage,
        // serverTime: state.store.home.serverTimeDate.time,
        // CheckedInGuest: state.store.CheckedInGuest,
        // currentWidget: state.store.sideNavBar.currentWidget,
        // serverDate: state.store.home.serverTimeDate,
        // deliveryLocations: state.store.Hcommerce.deliveryLocations,
        menuColor: state.store.home.MenuColor,
        currencyCode: state.store.home.clientConfig.currencyDetails ?
            state.store.home.clientConfig.currencyDetails.code : "",
        totalPrice: state.store.Hcommerce.totalPrice,
        hCommerceSavedOrders: state.store.Hcommerce.hCommerceSavedOrders,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        storeInfo: state.store.Hcommerce.storeInfo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        precisionLength: state.store.home.clientConfig.currencyDetails ?
        state.store.home.clientConfig.currencyDetails.precisionLength : "",
        SelectedNavComponent: state.store.Hcommerce.SelectedNavComponent,
    }
}

export default connect(
    mapStateToProps,
    {
        changePage,
        getGuestInRoom,
        // sendOrder,
        // popupOpenClose,
        // setLoadingMass,
        // getDeliveryLocation,
        // setOrderDetailPage
        setTotalOrderPrice,
        setShowPlaceOrder,
        setHCommerceSavedOrders,
        sendAnalytics
    }
)(withTranslation('translations')(MyOrder));